import React, { useState, useEffect } from 'react';
import "./BusinessIntelligence.css"
import SalesTologyFooter from '../SalesTologyFooter/SalesTologyFooter';
import Navbar from '../Navbar/Navbar';
import image6 from "../../assests/salestology-img06-1536x1024.webp"

const BusinessIntelligence = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Navbar />
      <div className="bi-container" style={{ marginTop: '80px' }}>
        <div className="bi-header">Business Intelligence</div>
        
        <div className={`bi-content ${isVisible ? 'visible' : ''}`}>
          <div className="bi-image">
            <img src={image6} />
          </div>
          
          <div className="bi-text">
            <h2 className="bi-title">Business Intelligence</h2>
            
            <p className="bi-description">
              We offer company specific reporting and analytics solutions that <span className="bi-highlight">do not require ongoing subscription costs</span>. We believe that, while off-the-shelf tools can be deployed quickly, they often lack the granularity needed by the business. We build it for you!
            </p>
            
            <p className="bi-examples">Here are some examples:</p>
            
            <ul className="bi-list">
              <li>Build and standardize sales KPIs.</li>
              <li>Integration of the sales KPIs across the CRM and reporting infrastructure.</li>
              <li>Company specific sales dashboards leveraging existing B.I. platforms.</li>
              <li>Win / Loss Analytics tools delivering clarity behind the reasons for losing deals.</li>
            </ul>
          </div>
        </div>
      </div>
      <SalesTologyFooter />
    </>
  );
};

export default BusinessIntelligence;